import { Accordion, AccordionDetails, AccordionSummary, Box, IconButton, Typography, useTheme } from '@mui/material'
import { ReactNode, useState } from 'react'
import OverflowWrapper from '../../components/Wrapper/OverflowWrapper'
import { useAppContext } from '../../context/AppSettingsContextProvider'

interface Props {
  title: string
  icon: ReactNode
  actionIcon?: ReactNode
  children: ReactNode
  contentHeight?: number | undefined
  scrollToBottom?: boolean
  disabled?: boolean
  action?: () => void
  extraActions?: ReactNode
}

function AccordionSetup({ title, icon, actionIcon, contentHeight, scrollToBottom, children, disabled, action, extraActions }: Props) {
  const { accordionState, setAccordionState } = useAppContext()
  const [expand, setExpand] = useState<boolean>(accordionState[title] ?? true)
  const theme = useTheme()

  const toggleAccordion = () => {
    setExpand(!expand)

    setAccordionState((prevState) => ({
      ...prevState,
      [title]: !expand,
    }))
  }

  return (
    <Accordion
      expanded={expand}
      disableGutters
      square
      sx={{
        border: `0.5px solid ${theme.palette.divider}`,
        '&:before': {
          display: 'none',
        },
      }}
    >
      <AccordionSummary
        component="div"
        sx={{
          height: '1px',
          borderRadius: '8px',
        }}
      >
        <Box
          sx={{
            alignItems: "center",
            display: "flex"
          }}>
          {icon}
        </Box>
        <Typography
          variant="body2"
          onClick={toggleAccordion}
          sx={{
            fontWeight: 600,
            width: "100%",
            alignSelf: 'center',
            marginLeft: 1,
            marginRight: 1
          }}>
          {title}
        </Typography>
        {extraActions && (
          <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
            {extraActions}
          </Box>
        )}
        <IconButton
          disabled={disabled}
          sx={{
            marginLeft: extraActions ? 0 : 'auto',
            marginRight: -1,
          }}
          size="small"
          onClick={action}
        >
          {actionIcon}
        </IconButton>
      </AccordionSummary>
      <OverflowWrapper maxHeight={contentHeight ? contentHeight : 500} scrollToBottom={scrollToBottom}>
        <AccordionDetails>{expand ? children : null}</AccordionDetails>
      </OverflowWrapper>
    </Accordion>
  );
}

export default AccordionSetup
